<div class="wrapper-modal">
  <div class="wrapper-modal-content cancel-subscription">
    <div class="modal-title">{{this.currentPlan?.plan === ExpertPlan.planId
      ? ('SUBSCRIPTION_PLANS.cancel_expert_subscription_plan' | translate)
      : this.currentPlan?.plan === CompanyPlan.planId
        ? ('SUBSCRIPTION_PLANS.cancel_company_subscription_plan' | translate)
        : ('SUBSCRIPTION_PLANS.cancel_a_lister_subscription_plan' | translate)}}</div>
    <div class="modal-description">
      {{this.currentPlan?.plan === ExpertPlan.planId
      ? ('SUBSCRIPTION_PLANS.are_you_sure_you_want_to_cancel_your_expert_subscription_plan_upon_cancellation_you_will_be_switched_to_the_free_plan_you_will_have_all_expert_features_until_your_subscription_ends_on' | translate)
      : this.currentPlan?.plan === CompanyPlan.planId
        ? ('SUBSCRIPTION_PLANS.are_you_sure_you_want_to_cancel_your_company_subscription_plan_upon_cancellation_you_will_be_switched_to_the_free_plan_you_will_have_all_company_features_until_your_subscription_ends_on' | translate)
        : ('SUBSCRIPTION_PLANS.are_you_sure_you_want_to_cancel_your_a_lister_subscription_plan_upon_cancellation_you_will_be_switched_to_the_free_plan_you_will_have_all_a_lister_features_until_your_subscription_ends_on' | translate)}}
      {{ currentPlan?.current_period_end * 1000 | date: 'MMMM d, yyyy' }}
    </div>
    <div class="modal-buttons">
      <button (click)="$event.stopPropagation(); cancelModal.emit()" class="custom-btn custom-btn--gray">
        <span>
          {{'GENERAL.cancel' | translate}}
        </span>
      </button>
      <button (click)="$event.stopPropagation(); confirmModal.emit()" class="custom-btn custom-btn--primary">
        <span>
          {{this.currentPlan?.plan === ExpertPlan.planId
          ? ('SUBSCRIPTION_PLANS.cancel_my_expert_plan' | translate)
          : this.currentPlan?.plan === CompanyPlan.planId
            ? ('SUBSCRIPTION_PLANS.cancel_my_company_plan' | translate)
            : ('SUBSCRIPTION_PLANS.cancel_my_a_lister_plan' | translate)}}
        </span>
      </button>
    </div>
  </div>
</div>
